// extracted by mini-css-extract-plugin
export var containerMb = "index-module--containerMb--4r3bo";
export var containerPc = "index-module--containerPc--18-ci";